
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/refund",
      function () {
        return require("private-next-pages/terms/refund/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/refund"])
      });
    }
  